<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Xem tài khoản: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :span="9">
              <el-form label-position="left" :model="modelData" ref="createModel" label-width="160px">
                <el-form-item prop="name" label="Tên khóa học :" class="form-item">
                  <span>{{ modelData.name }}</span>
                </el-form-item>
                <el-form-item prop="email" label="Email :" class="form-item">
                  <span style="color: red">{{ modelData.email }}</span>
                </el-form-item>
                <el-form-item prop="phone" label="Số điện thoại :" class="form-item">
                  <span>{{ modelData.phone }}</span>
                </el-form-item>
                <el-form-item prop="city_name" label="Địa chỉ" class="form-item">
                  <span>{{ modelData.city_name }}</span>
                </el-form-item>
                <el-form-item prop="birthday" label="Sinh nhật :" class="form-item">
                  <span>{{ modelData.birthday }}</span>
                </el-form-item>
                <el-form-item prop="sex_txt" label="Giới tính :" class="form-item input-daterange">
                  <span>{{ modelData.sex_txt }}</span>
                </el-form-item>
                <el-form-item prop="user_type_txt" label="Loại tài khoản :" class="form-item input-daterange">
                  <span>{{ modelData.user_type_txt }}</span>
                </el-form-item>
                <el-form-item label="Kích hoạt" prop="status">
                  <el-switch
                    active-color="#13ce66"
                    inactive-color="#7f8c8d"
                    disabled
                    v-model="modelData.status">
                  </el-switch>
                </el-form-item>
              </el-form>
              <img v-if="modelData.avatar_path" :src="modelData.avatar_path" class="course">
            </el-col>
            <el-col :span="15">
              <el-form label-position="top" :model="modelData" ref="createModel">
                <el-form-item prop="user_content" label="">
                  <div v-html="modelData.user_content"></div>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
export default {
  name: 'UserUpdate',
  metaInfo () {
    return {
      title: 'Tài khoản | Cập nhật'
    }
  },
  components: {

  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        email: '',
        phone: '',
        avatar: '',
        avatar_path: '',
        password: '',
        password_confirmation: '',
        address: '',
        birthday: '',
        sex: 1,
        user_type: '',
        user_content: '',
        status: true
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'users-for-editor-index', text: 'Tài khoản' },
        { name: 'users-create', text: 'Xem chi tiết' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'users-for-editor-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('users/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>

<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
.course {
  width: 200px;
  height: 200px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/users-for-editor/Show.vue